export default __webpack_public_path__ + "media/images/svg/view-locations-decor-2e5849be283e450b325b61047a0cee3f.svg";